import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { SecurityService } from '../../services/security.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { LoginResponseDTO } from '../login/login.costants';

@Component({
  selector: 'app-otp-login',
  templateUrl: './otp-login.component.html',
  styleUrls: ['./otp-login.component.css'],
})
export class OtpLoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  destroy$ = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private route: Router,
    private networkService: NetworkService,
    private securityService: SecurityService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      otpCode: ['', [Validators.required]],
    });
  }

  login(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      username: this.securityService.getUsername(),
      session: this.securityService.getSessionLogin(),
      code: this.loginForm?.controls['otpCode'].value,
    };
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.loginConfirmOtp;
    this.networkService
      .postNoToken(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (this.networkService.checkEnvironmentIsDev()) {
            if (
              response &&
              response.statusCode == '200' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');
              let loginResponseDto: LoginResponseDTO = JSON.parse(
                response.body
              );
              this.securityService.setToken(loginResponseDto.idToken);
              this.getUser();
            } else if (
              response &&
              response.statusCode == '500' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(response.body, 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            }
          } else {
            console.log(typeof response);
            if (response && response.idToken) {
              this.spinner.hide('sp1');
              let loginResponseDto: LoginResponseDTO = response;
              this.securityService.setToken(loginResponseDto.idToken);
              this.getUser();
            } else if (response && response.length && response.length > 0) {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr(response.toString(), 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            } else {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr(
                'Error during login confirm otp',
                'Error',
                { animate: 'slideFromRight', timeout: '3000' }
              );
            }
          }
        },
        (err) => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during login confirm otp', 'Error', {
            animate: 'slideFromRight',
            timeout: '3000',
          });
        }
      );
  }

  getUser(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      username: this.securityService.getUsername(),
      password: '',
    };
    let data = Utility.createBodyForPostRequest(userLoginDto);
    let urlLogin: string = environment.basePath + _ENDPOINT.getUser;
    this.networkService
      .post(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          let user: any;
          if (this.networkService.checkEnvironmentIsDev()) {
            user = JSON.parse(response.body);
            console.log(user);
            if (
              response &&
              response.statusCode == '200' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');

              this.securityService.setUser(user);
              this.securityService.setGroupUser(user);
              localStorage.setItem('user', JSON.stringify(user));
             
              if (this.isFirstLoginOrPasswordUpdateMoreThanSixMonths(user)) {
                this.route.navigate(['/change-password']);
              } else if (user.group.groupName != 'FAS_ADMIN' && user.group.groupName != 'ADMIN_FREEMOVE_FE') {
                this.spinner.hide('sp1');
                this.route.navigate(['/fwp/home']);
                return;
              } else {
                this.route.navigate(['/home']);
              }
            } else if (
              response &&
              response.statusCode == '500' &&
              response.body &&
              response.body.length > 0
            ) {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(response.body, 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            }
          } else {
            user = response;
            localStorage.setItem('user', JSON.stringify(user));
            if (response && response.username) {
              this.spinner.hide('sp1');
              this.securityService.setUser(response);
              this.securityService.setGroupUser(response);
              if (this.isFirstLoginOrPasswordUpdateMoreThanSixMonths(user)) {
                this.route.navigate(['/change-password']);
              } else if (user.group.groupName != 'FAS_ADMIN' && user.group.groupName != 'ADMIN_FREEMOVE_FE') {
                this.spinner.hide('sp1');
                this.route.navigate(['/fwp/home']);
                return;
              } else {
                this.route.navigate(['/home']);
              }
            } else if (response && response.length && response.length > 0) {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr(response.toString(), 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            } else {
              this.spinner.hide('sp1');
              console.log(response);
              this.toastr.errorToastr('Error during get user', 'Error', {
                animate: 'slideFromRight',
                timeout: '3000',
              });
            }
          }
        },
        (err) => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during get user', 'Error', {
            animate: 'slideFromRight',
            timeout: '3000',
          });
        }
      );
  }

  loginDisabled() {
    return this.loginForm?.invalid;
  }

  isFirstLoginOrPasswordUpdateMoreThanSixMonths(response: any) {
    if (response.firstLogin && response.firstLogin == 'Y') {
      return true;
    } else if (
      response.dataLastUpdatePassword &&
      this.passwordUpdateMoreThanSixMonths(response.dataLastUpdatePassword)
    ) {
      return true;
    } else {
      return false;
    }
  }

  passwordUpdateMoreThanSixMonths(dataLastUpdatePassword: string) {
    let result: boolean = false;
    const date1 = new Date(dataLastUpdatePassword);
    const date2 = new Date();

    const msBetweenDates = date2.getTime() - date1.getTime();

    let month, day, hour, minute, second;

    second = Math.floor(msBetweenDates / 1000);
    minute = Math.floor(second / 60);
    second = second % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    month = Math.floor(day / 30);
    if (month >= 6) {
      result = true;
    }
    return result;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
